<template>
  <div>
    <svg width="100%" height="100%">
      <!-- 渐变颜色一 通过id获取  -->
      <defs>
        <linearGradient id="yellow" x1="100%" y1="0%" x2="0%" y2="50%">
          <stop offset="0%" style="stop-color:#FFFAEE" stop-opacity="1"></stop>
          <stop offset="100%" style="stop-color:#F9BA0E" stop-opacity="1"></stop>
        </linearGradient>
      </defs>
      <!--  渐变颜色二 通过id获取 -->
      <defs>
        <linearGradient id="blue" x1="100%" y1="0%" x2="0%" y2="50%">
          <stop offset="0%" style="stop-color:#CBE3FF" stop-opacity="1"></stop>
          <stop offset="100%" style="stop-color:#0065FC" stop-opacity="1"></stop>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'svgLinearGradient'
}
</script>

<style lang="less" scoped>
</style>